(function () {
   'use strict';

   var logger = new (require('../helpers/logger.js'))("VideoPlayer Initializer").setColor("#212157");
   var helper = require('../helpers/generic.js');
   var videoHelper = require('./helper.js');
   var ACClient = require('../AssetCore/client.js');
   var jquery = require('jquery');

   module.exports = {
     videoFromData: videoFromData,
     videoWithOverlay: videoWithOverlay,
     smartmovieFromUrl: smartmovieFromUrl
  };

  var client = null;
  function lazyInitClient(){
    if (helper.undefOrNull(client)){
      client = new ACClient();
    }
    return client;
  }

  function _getPromise(mediaCodeOrUrl){
    return lazyInitClient().getMediaPromise(mediaCodeOrUrl);
  }

  function _getPromises(videoCode, posterCodeOrUrl){
    var posterPromise = _getPromise(posterCodeOrUrl);
    var videoPromise = _getPromise(videoCode);
    return jquery.when(videoPromise, posterPromise);
  }

  function smartmovieFromUrl(storyboardUrl, container, defaultQuality, options){
    return videoHelper.fromSmartmovieUrl(storyboardUrl, container, null, defaultQuality, options);
  }

  function videoWithOverlay(videoCode, container, posterCodeOrUrl, options){
    var deferredPlayer = jquery.Deferred();
    var videoAndPosterMedia = _getPromises(videoCode, posterCodeOrUrl);
    videoAndPosterMedia.done(function( video, poster ){
      var player = videoHelper.fromMediaOrUrl(video, false, container, poster, null, options, null, null);
      deferredPlayer.resolve(player, player.getMedia());
    }).fail(function(msg){
      deferredPlayer.reject(msg);
    });
    return deferredPlayer;
  }

  function videoFromData(element, options){
    // var inline=true; createVideoPlayerForElement( inline, element );
    var $element = $(element);

    var poster = $element.data("poster");
    var forcePosterDimensions = $element.data("forcePosterDimensions");
    var omitPosterElement = $element.data("omitPosterElement");
    var videoCode = $element.data("video");
    var smartmovieUrl = $element.data("smartmovie");
    var defaultQuality = $element.data("quality");
    var overlay = $element.data("overlay");
    var play = $element.data("play");
    var playHover = $element.data("playHover");
    var inheritMaxWidthFrom = $element.data("inheritMaxWidthFrom");

    var inline = helper.undefOrNull(overlay) || overlay===false || overlay==='false';
    var deferredPlayer = jquery.Deferred();

    if (helper.undefOrNull(options)){
      options = {};
    }

    if (!helper.undefOrNull(forcePosterDimensions)){
      $.extend( true, options, { forcePosterDimensions: forcePosterDimensions } );
    }
    if (!helper.undefOrNull(omitPosterElement)){
      $.extend( true, options, { omitPosterElement: omitPosterElement } );
    }
    if (!helper.undefOrNull(inheritMaxWidthFrom)){
      $.extend( true, options, { inheritMaxWidthFrom: inheritMaxWidthFrom } );
    }

    if (!helper.undefOrNull(videoCode)){ // load media from assetCore
      var videoAndPosterMedia = _getPromises(videoCode, poster);
      videoAndPosterMedia.done(function( video, poster ){
        var player = videoHelper.fromMediaOrUrl(video, inline, $element, poster, defaultQuality, options, play, playHover);
        if (!inline){
          $element.css({ cursor: 'pointer' });
          $element.click(function(){
            player.play();
          });
        }
        deferredPlayer.resolve(player, player.getMedia());
      }).fail(function( message ){
        deferredPlayer.reject( message );
      });
    } else if (!helper.undefOrNull(smartmovieUrl)){
      var posterPromise = _getPromise(poster);
      jquery.when(posterPromise).done(function( poster ){
        var player = videoHelper.fromSmartmovieUrl(smartmovieUrl, $element, poster, defaultQuality, options, play, playHover);
        $element.css({ cursor: 'pointer' });
        $element.click(function(){
          player.play();
        });
        deferredPlayer.resolve(player, player.getMedia());
      }).fail(function(msg){
        deferredPlayer.reject(msg);
      });
    } else {
      deferredPlayer.reject("no correct media data given");
    }

    return deferredPlayer.promise();
  }

}());



//////////////////
// WEBPACK FOOTER
// ./src/VideoPlayer/initializers.js
// module id = 28
// module chunks = 0